module.exports = __webpack_public_path__ + "img/0392816c5d9231b9d99b1eb5010c2225.jpg";